/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.convo.updateAllRead'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{ knownValues: ['request', 'accepted'] }>(),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  updatedCount: /*#__PURE__*/ l.integer(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Sets conversations from a user as read to the latest message, with filters. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

export const $lxm = $nsid
